import { usePermanent } from "@suse-o11y/use-permanent";
import React from "react";

import { ToggleListStateContextProvider } from "./_toggle-list-state-context";
import { ToggleListState } from "./ToggleListState";

/**
 * Provides the ToggleListState to the children.
 * Should be mounted close to the root of the application.
 */
export const ToggleListStateProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
	const state = usePermanent(() => new ToggleListState());

	return <ToggleListStateContextProvider value={state}>{children}</ToggleListStateContextProvider>;
};
